const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  DASHBOARDLIST_REQUEST: 'DASHBOARD_LIST_REQUEST',
  DASHBOARDLIST_SUCCESS: 'DASHBOARD_LIST_SUCCESS',
  DASHBOARDLIST_FAILURE: 'DASHBOARD_LIST_FAILURE',

  ASSETLIST_REQUEST: 'ASSET_LIST_REQUEST',
  ASSETLIST_SUCCESS: 'ASSET_LIST_SUCCESS',
  ASSETLIST_FAILURE: 'ASSET_LIST_FAILURE',

  ASSETLIST_SEARCH_REQUEST: 'ASSET_LIST_SEARCH_REQUEST',
  ASSETLIST_SEARCH_SUCCESS: 'ASSET_LIST_SEARCH_SUCCESS',
  ASSETLIST_SEARCH_FAILURE: 'ASSET_LIST_SEARCH_FAILURE',

  ASSETDETAIL_REQUEST: 'ASSET_DETAIL_REQUEST',
  ASSETDETAIL_SUCCESS: 'ASSET_DETAIL_SUCCESS',
  ASSETDETAIL_FAILURE: 'ASSET_DETAIL_FAILURE',

  UPLOAD_ASSET_REQUEST: 'UPLOAD_ASSET_REQUEST',
  UPLOAD_ASSET_SUCCESS: 'UPLOAD_ASSET_SUCCESS',
  UPLOAD_ASSET_FAILURE: 'UPLOAD_ASSET_FAILURE',

  INSPECTIONLIST_REQUEST: 'INSPECTION_LIST_REQUEST',
  INSPECTIONLIST_SUCCESS: 'INSPECTION_LIST_SUCCESS',
  INSPECTIONLIST_FAILURE: 'INSPECTION_LIST_FAILURE',

  INSPECTIONLIST_SEARCH_REQUEST: 'INSPECTION_LIST_SEARCH_REQUEST',
  INSPECTIONLIST_SEARCH_SUCCESS: 'INSPECTION_LIST_SEARCH_SUCCESS',
  INSPECTIONLIST_SEARCH_FAILURE: 'INSPECTION_LIST_SEARCH_FAILURE',

  INSPECTIONDETAIL_REQUEST: 'INSPECTION_DETAIL_REQUEST',
  INSPECTIONDETAIL_SUCCESS: 'INSPECTION_DETAIL_SUCCESS',
  INSPECTIONDETAIL_FAILURE: 'INSPECTION_DETAIL_FAILURE',

  APPROVEINAPECTION_REQUEST: 'APPROVE_INAPECTION_REQUEST',
  APPROVEINAPECTION_SUCCESS: 'APPROVE_INAPECTION_SUCCESS',
  APPROVEINAPECTION_FAILURE: 'APPROVE_INAPECTION_FAILURE',

  WORKORDERLIST_REQUEST: 'WORKORDER_LIST_REQUEST',
  WORKORDERLIST_SUCCESS: 'WORKORDER_LIST_SUCCESS',
  WORKORDERLIST_FAILURE: 'WORKORDER_LIST_FAILURE',

  WORKORDERLIST_SEARCH_REQUEST: 'WORKORDER_LIST_SEARCHREQUEST',
  WORKORDERLIST_SEARCH_SUCCESS: 'WORKORDER_LIST_SEARCHSUCCESS',
  WORKORDERLIST_SEARCH_FAILURE: 'WORKORDER_LIST_SEARCHFAILURE',

  WORKORDERDETAIL_REQUEST: 'WORKORDER_DETAIL_REQUEST',
  WORKORDERDETAIL_SUCCESS: 'WORKORDER_DETAIL_SUCCESS',
  WORKORDERDETAIL_FAILURE: 'WORKORDER_DETAIL_FAILURE',

  WORKORDERCREATE_REQUEST: 'WORKORDER_CREATE_REQUEST',
  WORKORDERCREATE_SUCCESS: 'WORKORDER_CREATE_SUCCESS',
  WORKORDERCREATE_FAILURE: 'WORKORDER_CREATE_FAILURE',

  WORKORDERUPDATE_REQUEST: 'WORKORDER_UPDATE_REQUEST',
  WORKORDERUPDATE_SUCCESS: 'WORKORDER_UPDATE_SUCCESS',
  WORKORDERUPDATE_FAILURE: 'WORKORDER_UPDATE_FAILURE',

  GETALLCOMPANY_REQUEST: 'GET_ALL_COMPANY_REQUEST',
  GETALLCOMPANY_SUCCESS: 'GET_ALL_COMPANY_SUCCESS',
  GETALLCOMPANY_FAILURE: 'GET_ALL_COMPANY_FAILURE',

  GENERATE_BARCODE_REQUEST: 'GENERATE_BARCODE_REQUEST',
  GENERATE_BARCODE_SUCCESS: 'GENERATE_BARCODE_SUCCESS',
  GENERATE_BARCODE_FAILURE: 'GENERATE_BARCODE_FAILURE',

  VALIDATE_ASSET_REQUEST: 'VALIDATE_ASSET_REQUEST',
  VALIDATE_ASSET_SUCCESS: 'VALIDATE_ASSET_SUCCESS',
  VALIDATE_ASSET_FAILURE: 'VALIDATE_ASSET_FAILURE',

  ASSET_INSPECTION_SEARCH_LIST_REQUEST: 'ASSET_INSPECTION_SEARCH_LIST_REQUEST',
  ASSET_INSPECTION_SEARCH_LIST_SUCCESS: 'ASSET_INSPECTION_SEARCH_LIST_SUCCESS',
  ASSET_INSPECTION_SEARCH_LIST_FAILURE: 'ASSET_INSPECTION_SEARCH_LIST_FAILURE',

  ASSET_INSPECTION_LIST_REQUEST: 'ASSET_INSPECTION_LIST_REQUEST',
  ASSET_INSPECTION_LIST_SUCCESS: 'ASSET_INSPECTION_LIST_SUCCESS',
  ASSET_INSPECTION_LIST_FAILURE: 'ASSET_INSPECTION_LIST_FAILURE',

  ASSET_WORKORDER_LIST_REQUEST: 'ASSET_WORKORDER_LIST_REQUEST',
  ASSET_WORKORDER_LIST_SUCCESS: 'ASSET_WORKORDER_LIST_SUCCESS',
  ASSET_WORKORDER_LIST_FAILURE: 'ASSET_WORKORDER_LIST_FAILURE',

  ASSET_WORKORDER_SEARCH_LIST_REQUEST: 'ASSET_WORKORDER_SEARCH_LIST_REQUEST',
  ASSET_WORKORDER_SEARCH_LIST_SUCCESS: 'ASSET_WORKORDER_SEARCH_LIST_SUCCESS',
  ASSET_WORKORDER_SEARCH_LIST_FAILURE: 'ASSET_WORKORDER_SEARCH_LIST_FAILURE',

  USER_LIST_REQUEST: 'USER_LIST_REQUEST',
  USER_LIST_SUCCESS: 'USER_LIST_SUCCESS',
  USER_LIST_FAILURE: 'USER_LIST_FAILURE',

  GET_USER_ROLES_REQUEST: 'GET_USER_ROLES_REQUEST',
  GET_USER_ROLES_SUCCESS: 'GET_USER_ROLES_SUCCESS',
  GET_USER_ROLES_FAILURE: 'GET_USER_ROLES_FAILURE',

  CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
  CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
  CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',

  UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',

  UPDATE_USER_STATUS_REQUEST: 'UPDATE_USER_STATUS_REQUEST',
  UPDATE_USER_STATUS_SUCCESS: 'UPDATE_USER_STATUS_SUCCESS',
  UPDATE_USER_STATUS_FAILURE: 'UPDATE_USER_STATUS_FAILURE',

  USER_DETAIL_REQUEST: 'USER_DETAIL_REQUEST',
  USER_DETAIL_SUCCESS: 'USER_DETAIL_SUCCESS',
  USER_DETAIL_FAILURE: 'USER_DETAIL_FAILURE',

  USER_LIST_SEARCH_REQUEST: 'USER_LIST_SEARCH_REQUEST',
  USER_LIST_SEARCH_SUCCESS: 'USER_LIST_SEARCH_SUCCESS',
  USER_LIST_SEARCH_FAILURE: 'USER_LIST_SEARCH_FAILURE',

  NOTIFICATION_LIST_REQUEST: 'NOTIFICATION_LIST_REQUEST',
  NOTIFICATION_LIST_SUCCESS: 'NOTIFICATION_LIST_SUCCESS',
  NOTIFICATION_LIST_FAILURE: 'NOTIFICATION_LIST_FAILURE',

  GENERATE_BARCODE_USER_REQUEST: 'GENERATE_BARCODE_USER_REQUEST',
  GENERATE_BARCODE_USER_SUCCESS: 'GENERATE_BARCODE_USER_SUCCESS',
  GENERATE_BARCODE_USER_FAILURE: 'GENERATE_BARCODE_USER_FAILURE',

  UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
  UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
  UPDATE_USER_PROFILE_FAILURE: 'UPDATE_USER_PROFILE_FAILURE',

  USER_DETAIL_PROFILE_REQUEST: 'USER_DETAIL_PROFILE_REQUEST',
  USER_DETAIL_PROFILE_SUCCESS: 'USER_DETAIL_PROFILE_SUCCESS',
  USER_DETAIL_PROFILE_FAILURE: 'USER_DETAIL_PROFILE_FAILURE',

  UPLOAD_INSPECTIONFORMS_REQUEST: 'UPLOAD_INSPECTIONFORMS_REQUEST',
  UPLOAD_INSPECTIONFORMS_SUCCESS: 'UPLOAD_INSPECTIONFORMS_SUCCESS',
  UPLOAD_INSPECTIONFORMS_FAILURE: 'UPLOAD_INSPECTIONFORMS_FAILURE',

  GENERATE_REPORT_LIST_REQUEST: 'GENERATE_REPORT_LIST_REQUEST',
  GENERATE_REPORT_LIST_SUCCESS: 'GENERATE_REPORT_LIST_SUCCESS',
  GENERATE_REPORT_LIST_FAILURE: 'GENERATE_REPORT_LIST_FAILURE',

  GENERATE_REPORT_2_LIST_REQUEST: 'GENERATE_REPORT_2_LIST_REQUEST',
  GENERATE_REPORT_2_LIST_SUCCESS: 'GENERATE_REPORT_2_LIST_SUCCESS',
  GENERATE_REPORT_2_LIST_FAILURE: 'GENERATE_REPORT_2_LIST_FAILURE',

  GENERATE_REPORT_3_LIST_REQUEST: 'GENERATE_REPORT_3_LIST_REQUEST',
  GENERATE_REPORT_3_LIST_SUCCESS: 'GENERATE_REPORT_3_LIST_SUCCESS',
  GENERATE_REPORT_3_LIST_FAILURE: 'GENERATE_REPORT_3_LIST_FAILURE',

  GENERATE_REPORT_4_LIST_REQUEST: 'GENERATE_REPORT_4_LIST_REQUEST',
  GENERATE_REPORT_4_LIST_SUCCESS: 'GENERATE_REPORT_4_LIST_SUCCESS',
  GENERATE_REPORT_4_LIST_FAILURE: 'GENERATE_REPORT_4_LIST_FAILURE',

  OUTSTANDING_ISSUE_LIST_REQUEST: 'OUTSTANDING_ISSUE_LIST_REQUEST',
  OUTSTANDING_ISSUE_LIST_SUCCESS: 'OUTSTANDING_ISSUE_LIST_SUCCESS',
  OUTSTANDING_ISSUE_LIST_FAILURE: 'OUTSTANDING_ISSUE_LIST_FAILURE',

  UPDATE_METER_HOUR_REQUEST: 'UPDATE_METER_HOUR_REQUEST',
  UPDATE_METER_HOUR_SUCCESS: 'UPDATE_METER_HOUR_SUCCESS',
  UPDATE_METER_HOUR_FAILURE: 'UPDATE_METER_HOUR_FAILURE',

  UPDATE_EMAIL_NOTIFICATION_REQUEST: 'UPDATE_EMAIL_NOTIFICATION_REQUEST',
  UPDATE_EMAIL_NOTIFICATION_SUCCESS: 'UPDATE_EMAIL_NOTIFICATION_SUCCESS',
  UPDATE_EMAIL_NOTIFICATION_FAILURE: 'UPDATE_EMAIL_NOTIFICATION_FAILURE',

  HISTORY_OF_INSPECTION_ASSET_REPORT_REQUEST: 'HISTORY_OF_INSPECTION_ASSET_REPORT_REQUEST',
  HISTORY_OF_INSPECTION_ASSET_REPORT_SUCCESS: 'HISTORY_OF_INSPECTION_ASSET_REPORT_SUCCESS',
  HISTORY_OF_INSPECTION_ASSET_REPORT_FAILURE: 'HISTORY_OF_INSPECTION_ASSET_REPORT_FAILURE',

  GENERATE_INSPECTION_OF_ASSET_REPORT_REQUEST: 'GENERATE_INSPECTION_OF_ASSET_REPORT_REQUEST',
  GENERATE_INSPECTION_OF_ASSET_REPORT_SUCCESS: 'GENERATE_INSPECTION_OF_ASSET_REPORT_SUCCESS',
  GENERATE_INSPECTION_OF_ASSET_REPORT_FAILURE: 'GENERATE_INSPECTION_OF_ASSET_REPORT_FAILURE',

  CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_REQUEST: 'CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_REQUEST',
  CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_SUCCESS: 'CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_SUCCESS',
  CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_FAILURE: 'CHECK_STATUS_INSPECTION_OF_ASSET_REPORT_FAILURE',

  GET_ALL_ASSET_ID_LIST_REQUEST: 'GET_ALL_ASSET_ID_LIST_REQUEST',
  GET_ALL_ASSET_ID_LIST_SUCCESS: 'GET_ALL_ASSET_ID_LIST_SUCCESS',
  GET_ALL_ASSET_ID_LIST_FAILURE: 'GET_ALL_ASSET_ID_LIST_FAILURE',

  UPDATE_ASSET_STATUS_REQUEST: 'UPDATE_ASSET_STATUS_REQUEST',
  UPDATE_ASSET_STATUS_SUCCESS: 'UPDATE_ASSET_STATUS_SUCCESS',
  UPDATE_ASSET_STATUS_FAILURE: 'UPDATE_ASSET_STATUS_FAILURE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',

  UPDATE_ASSET_FILTER_STATE: 'UPDATE_ASSET_FILTER_STATE',
  UPDATE_INSPECTION_FILTER_STATE: 'UPDATE_INSPECTION_FILTER_STATE',
  UPDATE_WORKORDER_FILTER_STATE: 'UPDATE_WORKORDER_FILTER_STATE',
  UPDATE_USER_FILTER_STATE: 'UPDATE_USER_FILTER_STATE',

  CHANGE_MR_OPEN_COUNT: 'CHANGE_MR_OPEN_COUNT',
}
export default userConstants
